<template>
    <section class="container-fluid shop">
        <div class="row "><div class="col-12"></div></div>
    
        <div class="row" data-aos="fade-up" >
            <div class="col-12 p-0">
                <div class="row g-0 align-items-stretch" data-aos="fade-up">
                    <div class="col-12 col-md-6 p-0" style="overflow: hidden; position: relative;">
                        <img :src="$url + '/uploads/featured/contacto.jpg'" alt="Contacto" class="d-block" style="position:absolute; inset:0; width:100%; height:100%; object-fit: cover; object-position: center;" />
                    </div>
                    <div class="col-12 col-md-6 p-4 p-md-5">
                        <h1 v-if="$store.state.lang == 'es'" class="title text-center">Contacto</h1>
                        <h1 v-else class="title text-center">Contact Me</h1>
                        <form @submit.prevent="sendForm()">
                            <ul class="list-unstyled contact-form">
                                <input type="hidden" name="token" v-model="googleToken" />
                                <GoogleCaptcha sitekey="6LeZcSsqAAAAAGy84r_3Vpop-XD1OfZB2_n8Tkca" action="submit" v-on:google_captcha_token="updateToken" ref="captcha"></GoogleCaptcha>

                                <li>
                                    <input type="text" class="form-control" v-model="contact.name" :placeholder=" $store.state.lang == 'es' ? 'Nombre':'Name' ">
                                </li>
                                <li>
                                    <input type="email" class="form-control" v-model="contact.email" :placeholder=" $store.state.lang == 'es' ? 'Correo':'Email' ">
                                </li>
                                <li>
                                    <input type="text" class="form-control" v-model="contact.phone" :placeholder=" $store.state.lang == 'es' ? 'Teléfono' : 'Phone'">
                                </li>
                                <li>
                                    <textarea class="form-control" rows="5" v-model="contact.message" :placeholder=" $store.state.lang == 'es' ? 'Mensaje':'Message'"></textarea>
                                </li>
                                <li class="text-center">
                                    <button type="submit" class="btn btn-black btn-block">{{$store.state.lang == 'es' ? 'ENVIAR':'SEND' }}</button>
                                </li>
                            </ul>
                        </form>
                    </div>
                </div>
            </div>

        </div>
       
    </section>
</template>

<script>

import FacebookIcon from 'vue-material-design-icons/Facebook.vue'
import InstagramIcon from 'vue-material-design-icons/Instagram.vue'
import axios from 'axios'
export default {
    name: 'ContactComponent',
    components: { FacebookIcon, InstagramIcon },
    data(){
        return{
            show:false,
            contact:[],
            googleToken: null,
        }
    },
   
    methods:{
        sendForm(){
            if(this.contact.name == '' || this.contact.email=='' || this.contact.phone == '' || this.contact.message == ''){
                return
            }
            axios.post(this.$url+'/contact',{  accion: 'contact', name: this.contact.name, email: this.contact.email, phone: this.contact.phone, message: this.contact.message  },{
                headers: {'Content-Type' : 'application/json'}
            })
            .then(()=>{
               
            }).catch((err)=>{
                console.log(err)
            })
        },
        updateToken(payload){
          this.googleToken = payload.response_token;
        },
        formSubmit(){
            this.$refs.captcha.generateManualToken().then((token) => {
                //use token here
            });
        }
    }
}
</script>